import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedVideo: {},
  assignmentMarkPayload: {},
}; // define your initial state object here

export const coursePlayerSlice = createSlice({
  name: "coursePlayer",
  initialState,
  reducers: {
    selectVideo: (state, action) => {
      state.selectedVideo = action.payload;
    },
    setAssignmentMarkPayload: (state, action) => {
      state.assignmentMarkPayload = action.payload;
    },
  },
});

export const { selectVideo, setAssignmentMarkPayload } =
  coursePlayerSlice.actions;
export default coursePlayerSlice.reducer;
